export default "__VITE_ASSET__3_n1rkdw__"